<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Términos y condiciones</h3>
        <label>
          <div v-show="form.estado == 'N'" class="noti-secondary">Estado: <strong>NUEVO</strong></div>
          <div v-show="form.estado == 'A'" class="noti-success">Estado: <strong>ACTIVO</strong></div>
          <div v-show="form.estado == 'I'" class="noti-danger">Estado: <strong>INACTIVO</strong></div>
        </label>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <div class="card">
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-12">
                <div class="form-field">
                  <textarea-field :disabled="disabledInput" v-model="form.contenido" stretch id="contenido" placeholder="Escriba el contenido...">
                    <span>Contenido*</span>
                    <span v-if="errores.contenido" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.contenido[0] }}</strong>
                    </span>
                  </textarea-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="file-upload-field">
                    <label>Archivo PDF
                      <span v-if="errores.path_archivo" class="helper-text text-danger" slot="helper">
                        <strong>{{ errores.path_archivo[0] }}</strong>
                      </span>
                    </label>
                    <file-upload2 v-model="form.path_archivo" id="path_archivo" ref="path_archivo"
                      :defaultImage="(form.path_archivo != '' && form.path_archivo != null) ? url + '/images/imagen-pdf.jpg' : ''"
                      :tamanoMaximo="20000000" :descripcionMaximo="'20mb'" :extensiones="'.pdf'" />
                  </div>
                </div>
                <footer class="blockquote-footer" style="color: #6d7684">.pdf</footer>
              </div>
              <div class="col-xs-12 col-md-2">
                <div class="form-inline">
                  <button @click="botonDescargarArchivo(form.path_archivo)"
                    v-show="form.path_archivo.substring(0, 30) == '/storage/terminos-condiciones/'" class="btn-info" type="button">
                    <i class="fa fa-download"></i>
                  </button>
                  <button @click="botonQuitarArchivo($refs.path_archivo.id)"
                    v-show="form.path_archivo != '' && form.path_archivo != null" class="btn-danger" type="button">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button @click="botonGuardar" :disabled="disableButton" class="btn-success"><i class="fa fa-save"></i><span>Guardar</span></button>
            <button @click="botonLimpiar" :disabled="disableButton" class="btn-primary btn--text"><i class="fa fa-refresh"></i><span>Limpiar</span></button>
            <button @click="cerrarModal" class="btn-danger"><i class="fa fa-times-circle"></i><span>Cerrar</span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    propTerminosCondiciones: {
      type: Object,
      required: false,
      default: function(){
        return null;
      }
    }
  },
  data() {
    return {
      url: url,
      disableButton: false,
      disabledInput: false,
      reactivar: false,
      anular: false,
      terminos_condiciones: this.propTerminosCondiciones,
      form: {
        id: '',
        contenido: '',
        path_archivo: '',
        estado: 'N',
      },
      errores: {
        contenido: undefined,
        path_archivo: undefined,
      }
    }
  },
  watch: {
    "form.path_archivo"() {
      let file = document.getElementById("path_archivo").files[0];
      if (file) {
        if (file.type != "application/pdf") {
          let anterior = "", img = "";
          if (this.$refs.path_archivo.value.substring(0, 5) != "data:" && this.$refs.path_archivo.value != "") {
            anterior = this.$refs.path_archivo.value;
            img = url + "/images/imagen-pdf.jpg";
          }
          this.botonQuitarArchivo("path_archivo");
          this.form.path_archivo = anterior;
          this.$refs.path_archivo.image = img;
          swal.fire("No se permite subir este tipo de archivo.", "Aviso", "warning");
        } else
          this.$refs.path_archivo.image = url + "/images/imagen-pdf.jpg";
      }
    },
  },
  computed: {
    tieneId: function(){
      return this.form.id != '' && this.form.id != null;
    }
  },
  mounted() {
    if(this.terminos_condiciones != null){
      this.disableButton = this.terminos_condiciones.disableButton;
      this.disabledInput = this.terminos_condiciones.disabledInput;
      this.reactivar = this.terminos_condiciones.reactivar;
      this.anular = this.terminos_condiciones.anular;
      this.form.id = this.terminos_condiciones.id;
      this.form.contenido = this.terminos_condiciones.contenido;
      this.form.path_archivo = this.terminos_condiciones.path_archivo;
      this.form.estado = this.terminos_condiciones.estado;
    }
  },
  methods: {
    botonDescargarArchivo: function (value) {
      window.open(url + value, '_blank');
    },
    botonQuitarArchivo: function (value) {
      switch (value) {
        case 'path_archivo':
          this.form.path_archivo = '';
          this.$refs.path_archivo.resetImagen();
          this.$refs.path_archivo.image = '';
          break;
        default:
          break;
      }
    },
    cerrarModal: function(){
      swal.fire({
        title: '¿Desea cerrar el formulario?',
        text: "Esta acción requiere de confirmación.",
        icon: 'question',
        showCancelButton: true,
        confirmButtonText:'Aceptar'
        }).then((result) => {
          if (result.value) {
            this.$modal.hide('terminosCondiciones');
          }
        });
    },
    limpiarErrores: function(){
      this.errores.contenido = null;
      this.errores.path_archivo = null;
    },
    limpiarCampos: function(){
      this.form.id = '';
      this.form.contenido = '';
      this.form.path_archivo = '';
      this.$refs.path_archivo.resetImagen();
      this.$refs.path_archivo.image = '';
      this.form.estado = 'N';
    },
    botonLimpiar: function(){
      swal.fire({
        title: '¿Desea limpiar los campos?',
        text: "Esta acción requiere de confirmación.",
        icon: 'question',
        showCancelButton: true,
        confirmButtonText:'Aceptar'
        }).then((result) => {
          if (result.value) {
            this.limpiarCampos();
            this.limpiarErrores();
          }
        });
    },
    interruptor: function (estado, bool) {
      this.form.estado = estado;
      this.disableButton = bool;
      this.disabledInput = bool;
      this.reactivar = bool;
      this.anular = estado == 'A'?true:false;
    },
    guardarDatos: function(estado, reactivar){
      swal.fire({
        title: '¿Deseas guardar los Términos y condiciones?',
        text: "Esta acción requiere de confirmación.",
        icon: 'question',
        showCancelButton: true,
        confirmButtonText:'Aceptar'
      }).then((result) => {
        if (result.value) {
          this.limpiarErrores();
          let urlApi = null;
          if(this.tieneId){
            urlApi = url + '/terminos-condiciones/update/' +this.form.id;
            this.form._method = 'PUT';
            this.form.estado = estado;
          }
          else
            urlApi = url + '/terminos-condiciones/store';
          axios.post(urlApi, this.form).then(response => {
            this.form.id = response.data.id;
            this.interruptor(estado, false);
            swal.fire('Aviso', 'Los Términos y condiciones han sido almacenado.', 'success');
            this.$modal.hide('terminosCondiciones');
            this.$emit('cargarFila', response.data);
          }).catch(error => {
            if(error !== undefined && error !== null){
              let response = error.response;
              if (response !== undefined && response !== null){
                let status = response.status;
                if(status === 422){
                  this.errores = response.data.errors;
                  this.form.estado = 'N';
                  swal.fire('Hubo un error en el formulario.', 'Aviso', 'warning');
                  return;
                }
              }
            }
            swal.fire('Hubo un error, intente nuevamente.', 'Error', 'error');
          });
        }
      });
    },
    botonGuardar: function(){
      this.guardarDatos('A');
    },
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/terminos-condiciones/TerminosCondiciones.vue